import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StickyMobileCTA() {
  const loc = useLocation();
  // Hide on contact page (form is already there)
  if (loc.pathname === "/contact") return null;

  return (
    <div className="yv-sticky-cta lg:hidden" data-testid="sticky-mobile-cta">
      <Link to="/contact" className="yv-btn yv-btn-primary w-full justify-center" data-testid="sticky-cta-link">
        Get a quote in 60 min <ArrowRight size={16} />
      </Link>
    </div>
  );
}
